// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBRUqENe_vETjNf3d7V3R33KJ18V4uOe1M",
  authDomain: "tripplanner-5fefc.firebaseapp.com",
  projectId: "tripplanner-5fefc",
  storageBucket: "tripplanner-5fefc.firebasestorage.app",
  messagingSenderId: "807103283721",
  appId: "1:807103283721:web:288cfd944dd3c9af45aed8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;